export const PRIO = 'PRIO_';
export const DEFAULT_VAT = 19;
export const DEFAULT_VAT_16 = 16;
export const DEFAULT_VAT_REDUCED = 7;
export const DEFAULT_VAT_REDUCED_5 = 5;
export const NULL_VAT = 0;
export const MENU_BUTTON_SIZE = 64;
export const ONE_DAY_IN_MILLISECONDS = 86400000;
export const TRANSLATED_BACKEND_ERROR = ['UnhandledException'];
